import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import CommunityDiscount from './CommunityDiscount';

async function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Senior & Veteran Discount',
    component: <AdminLayout><CommunityDiscount /></AdminLayout>,
  };
}

export default action;
